import React, { Fragment } from "react";
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDownIcon } from "@heroicons/react/outline";

const QUESTIONS = [
    {
        id: 2,
        question: 'I did not receive a temporary password, what should I do?',
        answer: 'You can contact your administrator for assistance, they will provide you with a new one',
      },
    {
      id: 2,
      question: 'I received a temporary password by email, what should I do?',
      answer: 'Use your email and the temporary password to attempt a first sign in, you will be asked to change it',
    },
    {
      id: 3,
      question:
        "I tried to sign in with the temporary password, but I get an Incorrect Password error.",
      answer:
        'Make sure you copy the temporary password correctly, beware of white spaces and special characters. If the problem persists, contact your administrator.',
    },
    {
      id: 4,
      question:
        'I tried to sign in with the temporary password, but I get a Password Attempts Exceeded error.',
      answer:
        "When you try to sign in with an incorrect password multiple times, the platform detects a suspicious behavior. You can try again after a couple of minutes.",
    },
    {
      id: 5,
      question: 'I tried to change the password, but it does not work.',
      answer: 'When you try to change your password, make sure they match and that you respected the password requirements',
    },
    {
      id: 6,
      question: 'I submitted a Forgot Password request, but I did not receive anything.',
      answer:
        "Your account is likely not activated yet, make sure to activate it using the temporary password.",
    },
    
  ];
export default function Faq() {
  return (
    <div>
      <div className="divide-y divide-gray-100">
        <AccordionPrimitive.Root
          type="multiple"
          className="bg-white rounded-[4px]  p-8"
        >
          {QUESTIONS.map(({ id, question, answer }, index) => (
            <Fragment key={id}>
              <AccordionPrimitive.Item value={id.toString()}>
                <AccordionPrimitive.Header className="flex">
                  <AccordionPrimitive.Trigger
                    className={`flex flex-1 items-start justify-between ${
                      index === 0
                        ? "pb-8"
                        : index === QUESTIONS.length - 1
                        ? "pt-8"
                        : "py-8"
                    }   [&[data-state=open]]:pb-2 font-medium transition-all  [&[data-state=open]>svg]:rotate-180`}
                  >
                    <h3 className="text-base text-left font-bold text-gray-900 ">
                      {question}
                    </h3>
                    <ChevronDownIcon className="shrink-0 transition-transform duration-200 w-5 h-5" />
                  </AccordionPrimitive.Trigger>
                </AccordionPrimitive.Header>

                <AccordionPrimitive.Content
                  className={`${
                    index === QUESTIONS.length - 1 ? "" : "pb-8"
                  } overflow-hidden transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down`}
                >
                  <p className="text-gray-900 text-sm font-light">{answer}</p>
                </AccordionPrimitive.Content>
              </AccordionPrimitive.Item>
              {index < QUESTIONS.length - 1 && (
                <div className="bg-gray-300 w-[screen] h-px -mx-8" />
              )}
            </Fragment>
          ))}
        </AccordionPrimitive.Root>
      </div>
    </div>
  );
}
